<template>
    <el-card shadow="never" class="reg-form">

        <div slot="header" class="clearfix">
            <span>{{ $t('registration_title') }}</span>
        </div>

        <el-form :model="model" status-icon label-width="170px" label-position="top">
            <el-form-item :label="$t('first_name')" prop="name" :error="error.name">
                <el-input v-model="model.name"></el-input>
            </el-form-item>
            <el-form-item label="E-mail" prop="email" :error="error.email">
                <el-input v-model="model.email"></el-input>
            </el-form-item>
            <el-form-item :label="$t('password')" prop="password" :error="error.password">
                <el-input type="password" v-model="model.password" show-password></el-input>
            </el-form-item>
            <el-form-item :label="$t('confirm_password')" prop="confirm_password" :error="error.confirm_password">
                <el-input type="password" v-model="model.confirm_password" show-password></el-input>
            </el-form-item>
            <el-form-item label="Telegram" prop="telegram" :error="error.telegram">
                <el-input v-model="model.telegram"></el-input>
            </el-form-item>
          <el-form-item :label="$t('your_traffic_source')" prop="about" :error="error.about">
            <el-input v-model="model.about" type="textarea"></el-input>
          </el-form-item>
          <el-form-item :label="$t('your_monthly_budget')" :error="error.budget">
            <el-radio-group v-model="model.budget">
              <el-radio label="$1000-3000">$1000-3000</el-radio>
              <el-radio label="$5000-10000">$5000-10000</el-radio>
              <el-radio label="$10000-30000">$10000-30000</el-radio>
              <el-radio label="$30000+">$30000+</el-radio>
            </el-radio-group>
          </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="reg()" :loading="loading_form">{{ $t('registration_button') }}</el-button>
                <router-link :to="{name: 'login'}" tag="el-button">
                    {{ $t('login_button') }}
                </router-link>
            </el-form-item>
        </el-form>
    </el-card>

</template>

<script>
    import * as Cookies from 'js-cookie'
    export default {
        name: "Register",
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if (vm.$store.getters.isAuthenticated) {
                    next({
                        path: '/statistic'
                    })
                }
            })
        },
        data () {
            return {
                model: {
                    parent_id: Cookies.get('ref')
                },
                error: {},
                loading_form: false
            }
        },
        mounted () {
            if (this.$route.query.ref) {
                Cookies.set('ref', this.$route.query.ref, { expires: 360 });
                this.model.parent_id = this.$route.query.ref;
                this.$router.replace({ path: '/register' });
            }
        },
        methods: {
            reg () {
                this.loading_form = true;
                this.$axios.post('/user/register', this.model).then((res) => {
                    this.$store.commit('setToken', res.data.access_token);
                    // if (typeof ym === "function") {
                    //     // eslint-disable-next-line no-undef
                    //     ym(55528171, 'reachGoal', 'register');
                    // }
                    this.$router.replace({ path: '/statistic' });
                    this.error = {};
                    this.loading_form = false;
                }).catch((error) => {
                    if (error.response.status  === 422) {
                        this.error = error.response.data;
                    }
                    this.loading_form=false;
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-card {
        margin-left: auto;
        margin-right: auto;
        width: 600px;
        .el-form {
            margin-top:17px;
        }
    }
    @media (max-width: 655px) {
        .el-card {
            width: 100%;
        }
    }
</style>
